import React, { useState } from "react";
import {
  BackgroundColorContext,
  backgroundColors,
} from "contexts/BackgroundColorContext";

export default function BackgroundColorWrapper(props) {
  // Cargar color guardado de localStorage o usar azul por defecto
  const [color, setColor] = useState(() => {
    const savedColor = localStorage.getItem('maecore-bg-color');
    return savedColor || backgroundColors.blue;
  });

  function changeColor(color) {
    setColor(color);
    // Guardar color en localStorage para que persista entre sesiones
    localStorage.setItem('maecore-bg-color', color);
  }

  return (
    <BackgroundColorContext.Provider
      value={{ color: color, changeColor: changeColor }}
    >
      {props.children}
    </BackgroundColorContext.Provider>
  );
}
